import { BrowserModule,Title } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { LocationStrategy, PathLocationStrategy,HashLocationStrategy } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AgmCoreModule } from '@agm/core';
import { TooltipModule } from 'ng2-tooltip-directive';
import { ShareModule } from 'ngx-sharebuttons';
import { ShareButtonModule } from 'ngx-sharebuttons/button';
import { ShareIconsModule } from 'ngx-sharebuttons/icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';



import { NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

import { AppComponent } from './app.component';

// Import containers
import { DefaultLayoutComponent } from './containers';

import { HttpErrorInterceptor } from './api/http-error.interceptor';
import { P404Component } from './views/error/404.component';
import { P500Component } from './views/error/500.component';
import { LoginComponent } from './views/login/login.component';
// import { RegisterComponent } from './views/register/register.component';
import { ForgetPasswordComponent } from './views/forget-password/forget-password.component';
import { RegisprospectComponent } from './views/regisprospect/regisprospect.component';
import { RegisterComponent } from './views/sgs/register/register.component';
import { RegisupdateComponent } from './views/regisnew/regisupdate.component';


const APP_CONTAINERS = [
  DefaultLayoutComponent
];

import {
  AppAsideModule,
  AppBreadcrumbModule,
  AppHeaderModule,
  AppFooterModule,
  AppSidebarModule,
} from '@coreui/angular';

// Import routing module
import { AppRoutingModule } from './app.routing';

// Import 3rd party components
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ChartsModule } from 'ng2-charts';

import { NotifikasiComponent } from './views/regisprospect/notifikasi.component';
import { UpdateprofileComponent } from './views/regisnew/updateprofile.component';
import { RegisnewComponent } from './views/regisnew/regisnew.component';
import { RegisorderComponent } from './views/regisnew/regisorder.component';
import { RegisdetailComponent } from './views/regisnew/regisdetail.component';
import { RegisproductComponent } from './views/regisnew/regisproduct.component';
import { RegispayComponent } from './views/regisnew/regispay.component';
import { RegisComponent } from './views/regisnew/regis.component';
import { RegisrefComponent } from './views/regisnew/regisref.component';
import { PurchaseComponent } from './views/external/purchase/purchase.component';
import { PdfComponent } from './views/external/pdf/pdf.component';
import { TncComponent } from './views/external/tnc/tnc.component';
import { TncapproveComponent } from './views/external/tnc/tncapprove.component';
import { ScrollTracker } from './views/external/tnc/ScrollTracker.directive';

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    AppAsideModule,
    AppBreadcrumbModule.forRoot(),
    AppFooterModule,
    AppHeaderModule,
    AppSidebarModule,
    PerfectScrollbarModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    ChartsModule,
    TooltipModule,
    NgbTooltipModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    ShareModule,
    ShareIconsModule,
    FontAwesomeModule,
    ShareButtonModule,
    AgmCoreModule.forRoot({
      // apiKey: 'AIzaSyASyYRBZmULmrmw_P9kgr7_266OhFNinPA',
      // apiKey: 'AIzaSyCbZ3MorhJBYmyROMf9EErEhGrONBhpGS4',
      // apiKey: 'AIzaSyAl7LJSm7eoe7KxS5HR6qVzBvGslrocLyQ',//firsmedie
      // apiKey: 'AIzaSyCDf4xTvd0Fg7R0-gblX2v7o8Qa0Bxpkyw',
      // apiKey: 'AIzaSyCoEm1IUA3RLCgleQN8Mbo_PIIP_2Y6cs0',//pinjam
      apiKey: 'AIzaSyBIknLayK22qvahC10EC2Bb6zNZy1W_FXc',//ko Hen
      // apiKey: 'AIzaSyBWyQQ1N9nfdMpmTHIUBj1XJx7Sr3TeT6I',//Om Michael
      language: 'en',
      libraries: ['geometry','places']
    })
  ],
  declarations: [
    AppComponent,
    ...APP_CONTAINERS,
    P404Component,
    P500Component,
    LoginComponent,
    // RegisterComponent,
    RegisterComponent,
    RegisupdateComponent,
    ForgetPasswordComponent,
    RegisprospectComponent,
    NotifikasiComponent,
    UpdateprofileComponent,
    RegisnewComponent,
    RegisorderComponent,
    RegisdetailComponent,
    RegisproductComponent,
    RegispayComponent,
    RegisComponent,
    RegisrefComponent,
    PurchaseComponent,
    PdfComponent,
    TncComponent,
    TncapproveComponent,
    ScrollTracker,
  ],
  providers: [
    {
      provide: LocationStrategy,
      useClass: PathLocationStrategy
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true
    },
    Title
  ],
  bootstrap: [ AppComponent ]
})
export class AppModule { }
